import React from "react";
import "../css/SchoolGems.css";
import { Link } from "react-router-dom";

const gems = [
  {
    id: "01",
    icon: "📚",
    title: "Academic Excellence",
    description:
      "Providing high-quality education with experienced teachers, innovative teaching methods, and excellent academic results.",
  },
  {
    id: "02",
    icon: "💻",
    title: "Digital Learning",
    description:
      "Smart classrooms, digital boards, online learning resources, and technology-driven education for future-ready students.",
  },
  {
    id: "03",
    icon: "🧠",
    title: "Critical Thinking",
    description:
      "Encouraging students to think independently, solve real-world problems, and build strong analytical skills.",
  },
  {
    id: "04",
    icon: "🎨",
    title: "Arts & Creativity",
    description:
      "Music, dance, painting, drama, and creative activities that inspire imagination and self-expression.",
  },
  {
    id: "05",
    icon: "🏆",
    title: "Sports & Fitness",
    description:
      "Modern sports facilities and professional coaching to promote physical fitness, teamwork, and discipline.",
  },
  {
    id: "06",
    icon: "🌍",
    title: "Leadership & Values",
    description:
      "Building confidence, responsibility, ethics, leadership qualities, and strong moral values in every student.",
  },
  {
    id: "07",
    icon: "🤝",
    title: "Community Service",
    description:
      "Encouraging students to contribute positively to society through service, compassion, and social awareness.",
  },
  {
    id: "08",
    icon: "🔬",
    title: "Innovation & STEM",
    description:
      "Hands-on learning through science, robotics, coding, and STEM projects that inspire innovation.",
  },
  {
    id: "09",
    icon: "🎯",
    title: "Career & Life Skills",
    description:
      "Preparing students for future success through communication, leadership, entrepreneurship, and life skills.",
  },
];

export default function SchoolGems() {
  return (
    <>
      <section
        className="holisticpillers"
        style={{
          backgroundImage:
            "linear-gradient(rgba(12,48,86,0.75), rgba(12,48,86,0.75)), url('/images/i.jpeg')",
        }}
      >
        <div className="school-gems-overlay"></div>

        <div className="school-gems-content">
          <span className="hero-tag">Sahara Public School</span>

          <h1>
            The 9 Pillars of
            <br />
            Holistic Education
          </h1>

          <p>
            At Sahara Public School, our holistic education model nurtures
            academic excellence, leadership, creativity, innovation,
            sportsmanship, ethics and life skills, empowering every student to
            become a confident and responsible global citizen.
          </p>

          <div className="hero-buttons">
        <button
  className="hero-btn"
  onClick={() => {
    const section = document.getElementById("nine-pillars");
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }}
>
  Explore 9 Pillars
</button>
<Link to="/admissionenquiryform" className="hero-btn-outline">
  Admission Enquiry
</Link>
          </div>
        </div>
      </section>
      <section className="what-is-gems">
        <div className="what-gems-left">
          <span className="what-tag">Holistic Education</span>

          <h2>What is 9 Gems?</h2>

          <p>
            The <strong>9 Gems Framework</strong> at Sahara Public School is a
            holistic learning model designed to nurture every dimension of a
            child's growth. It goes beyond academics by helping students build
            confidence, creativity, leadership, discipline and strong values.
          </p>

          <p>
            Each of the nine pillars represents an essential area of
            development, including academic excellence, digital learning,
            critical thinking, arts, sports, leadership, innovation, community
            service and life skills. Together, these pillars prepare students to
            become responsible, compassionate and future-ready global citizens.
          </p>

          <p>
            Through experiential learning, collaborative projects, technology,
            sports, cultural activities and value-based education, students gain
            the knowledge, skills and character needed to succeed in school,
            higher education and life.
          </p>
        </div>

        <div className="what-gems-right">
          <img src="./images/m.jpeg" alt="Students Learning" />
        </div>
      </section>
      <section id="nine-pillars">
      <section className="school-gems" id="school-gems">
        <div className="gems-header">
          <span className="gems-subtitle">WHY CHOOSE US</span>

          <h2>
            The <span>Sahara Public School</span> Difference
          </h2>

          <p>
            At Sahara Public School, we believe education goes beyond textbooks.
            Our holistic learning approach helps students achieve academic
            excellence while developing leadership, creativity, innovation, and
            lifelong values.
          </p>
        </div>

  {/* 9 Pillars Content */}
  <div className="gems-grid">
          {gems.map((gem) => (
            <div className="gem-card" key={gem.id}>
              <div className="gem-number">{gem.id}</div>

              <div className="gem-icon">{gem.icon}</div>

              <h3>{gem.title}</h3>

              <p>{gem.description}</p>
            </div>
          ))}
        </div>
</section>
        
      </section>
    </>
  );
}
